import { RequestConfig } from '~/common/services/requests';
import { Activity } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { PaginatedResponse } from '../../types/PaginatedResponse';
import { ACTIVITIES_BASE_PATH } from '../constants/activitiesPath';
import {
  ActivitySubjectType,
  MAP_ACTIVITY_SUBJECT_TYPE_TO_RESOURCE_PATH_SEGMENT,
} from '../constants/ActivitySubjectType';

export const getActivities = async (
  constructGet: ConstructGet,
  subjectType: ActivitySubjectType,
  subjectId: string,
  headers?: RequestConfig['headers'],
  params?: RequestConfig['params'],
) =>
  constructGet<PaginatedResponse<Activity[]>>(
    `${ACTIVITIES_BASE_PATH}/${MAP_ACTIVITY_SUBJECT_TYPE_TO_RESOURCE_PATH_SEGMENT[subjectType]}/${subjectId}`,
    {
      params,
      headers,
    },
  );
